const Storage = window.localStorage;

class StorageService {
  getItem = (key: string) => {
    const item = Storage.getItem(key);
    return item;
  };
  setItem = (key: string, value: any) => {
    Storage.setItem(key, value.toString());
  };
  removeItem = (key: string) => {
    Storage.removeItem(key);
  };
  getAccessToken = () => {
    const accessToken = this.getItem('accessToken');
    return accessToken;
  };
}

export default new StorageService();
